import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, take } from 'rxjs';
import { SEO } from '@app/_shared/_models';
import { PrismicService } from '../_shared/_services/prismic.service';
import { SeoService } from '../_shared/_services/seo.service';
import { IFaqPage } from './_prismic/faq';
import { MatExpansionModule } from '@angular/material/expansion';
import { ImageComponent } from '@app/_shared/_components/image/image.component';

@Component({
    selector: 'app-frequently-asked-questions',
    templateUrl: './frequently-asked-questions.component.html',
    styleUrls: ['./frequently-asked-questions.component.scss'],
    imports: [MatExpansionModule, ImageComponent]
})
export class FrequentlyAskedQuestionsComponent implements OnInit, OnDestroy {
  private readonly seoService = inject(SeoService);
  private readonly prismicService = inject(PrismicService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/logos/main_logo.png',
    metaDescription: 'Frequently asked questions for new spa and pool owners.  What chemicals are needed, how to balance water, how to test pH levels, and more tips for water care.',
    metaTitle: 'Frequently Asked Questions About Swimming Pool and Hot Tub Chemicals'
  };
  public faqPage!: IFaqPage;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  ngOnInit(): void {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/frequently-asked-questions');
    this.prismicService.getSingle('faq')
      .pipe(take(1))
      .subscribe((res: any) => {
        this.faqPage = {
          hero_image: res.data.hero_image,
          title: res.data.main_title,
          faq_hero_body: this.prismicService.getRichText(res.data.faq_hero_body),
          faq_subpages: this.prismicService.getFaqsFromSlice(res.data.body)
        }
      });
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
